import React from 'react';
import {
  BrowserRouter as Router
} from "react-router-dom";
// CSS
import './normalize.css'
import './App.css';
// Components
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';
// Pages
import AppContent from './components/AppContent';

const App = () => {

  return (
    <div className="App">
      
      <Router>

        <AppHeader />

        <AppContent />

        <AppFooter />

      </Router>

    </div>
  );
}

export default App;
